<template>
    <div>
      <!-- Statistiques générales -->
      <div v-if="loading" class="text-center my-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>
      
      <div v-else>
        <!-- Statistiques générales -->
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mb-4">
          <div class="col">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">Utilisateurs</h6>
                <h3 class="card-title">{{ stats.users?.total || 0 }}</h3>
                <p class="card-text">
                  <span class="badge bg-success">{{ stats.users?.active || 0 }} actifs</span>
                </p>
              </div>
            </div>
          </div>
          
          <div class="col">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">Abonnements</h6>
                <h3 class="card-title">{{ stats.subscriptions?.active || 0 }}</h3>
                <p class="card-text">
                  sur {{ stats.subscriptions?.total || 0 }} total
                </p>
              </div>
            </div>
          </div>
          
          <div class="col">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">Paiements</h6>
                <h3 class="card-title">{{ stats.payments?.completed || 0 }}</h3>
                <p class="card-text">
                  <span class="badge bg-warning text-dark">{{ stats.payments?.pending || 0 }} en attente</span>
                </p>
              </div>
            </div>
          </div>
          
          <div class="col">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-subtitle mb-2 text-muted">Revenus</h6>
                <h3 class="card-title">{{ formatCurrency(stats.revenue || 0) }}</h3>
                <p class="card-text">Total des paiements validés</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Distribution des forfaits -->
        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title mb-0">Distribution des abonnements</h5>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Forfait</th>
                        <th>Nombre d'abonnés</th>
                        <th>Pourcentage</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="pkg in stats.packageDistribution" :key="pkg.name">
                        <td>{{ pkg.name }}</td>
                        <td>{{ pkg.count }}</td>
                        <td>
                          {{ calculatePercentage(pkg.count, stats.subscriptions?.active) }}%
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Actions rapides -->
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="card h-100">
              <div class="card-header">
                <h5 class="card-title mb-0">Actions rapides</h5>
              </div>
              <div class="card-body">
                <div class="list-group">
                  <router-link to="/admin/users" class="list-group-item list-group-item-action d-flex align-items-center">
                    <i class="fas fa-users me-3"></i>
                    <div>
                      <div class="fw-bold">Gérer les utilisateurs</div>
                      <small>Voir, modifier ou supprimer des utilisateurs</small>
                    </div>
                  </router-link>
                  
                  <router-link to="/admin/subscriptions" class="list-group-item list-group-item-action d-flex align-items-center">
                    <i class="fas fa-star me-3"></i>
                    <div>
                      <div class="fw-bold">Gérer les abonnements</div>
                      <small>Activer ou désactiver des abonnements</small>
                    </div>
                  </router-link>
                  
                  <router-link to="/admin/payments?status=en_attente" class="list-group-item list-group-item-action d-flex align-items-center">
                    <i class="fas fa-money-bill-wave me-3"></i>
                    <div>
                      <div class="fw-bold">Valider les paiements en attente</div>
                      <small>{{ stats.payments?.pending || 0 }} paiements en attente</small>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          
          <div class="col-md-6 mb-4">
            <div class="card h-100">
              <div class="card-header">
                <h5 class="card-title mb-0">Dernières activités</h5>
              </div>
              <div class="card-body">
                <!-- Cette section pourrait afficher les dernières activités -->
                <p class="text-muted">Aucune activité récente à afficher.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { adminService } from '@/services/api';
  
  export default {
    name: 'AdminDashboard',
    setup() {
      const stats = ref({});
      const loading = ref(true);
      
    // Côté client dans AdminDashboard.vue
const loadStatistics = async () => {
  try {
    console.log('Chargement des statistiques...');
    const response = await adminService.getStatistics();
    console.log('Réponse reçue :', response);
    if (response.data.success) {
      stats.value = response.data.data;
      console.log('Statistiques chargées :', stats.value);
    } else {
      console.warn('Réponse avec succès=false:', response.data);
    }
  } catch (error) {
    console.error('Error loading statistics:', error.response || error);
  } finally {
    loading.value = false;
  }
};
      
      const formatCurrency = (value) => {
        return new Intl.NumberFormat('fr-DJ', {
          style: 'currency',
          currency: 'DJF',
          maximumFractionDigits: 0
        }).format(value);
      };
      
      const calculatePercentage = (value, total) => {
        if (!total) return 0;
        return Math.round((value / total) * 100);
      };
      
      onMounted(() => {
        loadStatistics();
      });
      
      return {
        stats,
        loading,
        formatCurrency,
        calculatePercentage
      };
    }
  };
  </script>